export class infos {
    nome: string = "";
    descricao: string = "";
    nivel?: number = 0;
}